import { configureStore } from "@reduxjs/toolkit";
import { persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage";
import CommonReducer from "./reducers/CommonReducer";
import ParkersReducer from "./reducers/ParkersReducer";
import UserReducer from "./reducers/UserReducer";
import BillingReducer from "./reducers/BillingReducer";
import AllocationsReducer from "./reducers/AllocationsReducer";
import MessagingReducer from "./reducers/MessagingReducer";
import localforage from "localforage";

// const persistConfig = {
//   key: "user",
//   storage,
// };

//const userPersistedReducer = persistReducer(persistConfig, userReducer);

const store = configureStore({
  reducer: {
    user: UserReducer,
    common: CommonReducer,
    parkers: ParkersReducer,
    billing: BillingReducer,
    allocations: AllocationsReducer,
    messaging: MessagingReducer
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }),
});

export default store;
